import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';
import { generateSvgId } from '../../../lib/svg';

export const IconPromotionalEmail = memo(
  forwardRef((props, ref) => {
    const svgId1 = useMemo(() => generateSvgId(), []);
    const svgId2 = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon {...props} ref={ref} viewBox="0 0 30 30" data-fill-none>
        <g clipPath={`url(#${svgId1})`}>
          <g clipPath={`url(#${svgId2})`}>
            <path
              d="M16.5 20.4409H5.45455C5.33399 20.4409 5.21838 20.393 5.13313 20.3078C5.04789 20.2225 5 20.1069 5 19.9864V7.45455C5 7.33399 5.04789 7.21838 5.13313 7.13313C5.21838 7.04789 5.33399 7 5.45455 7H24.5455C24.666 7 24.7816 7.04789 24.8669 7.13313C24.9521 7.21838 25 7.33399 25 7.45455V12.5"
              stroke="#2F393E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.5613 7H5.57952C5.5423 7.00015 5.50602 7.01172 5.47558 7.03315C5.44514 7.05458 5.42202 7.08484 5.40933 7.11984C5.39664 7.15483 5.395 7.19288 5.40462 7.22884C5.41425 7.2648 5.43468 7.29694 5.46316 7.32091L14.6759 15.08C14.708 15.1069 14.7485 15.1219 14.7904 15.1224C14.8323 15.1229 14.8731 15.1089 14.9059 15.0827L24.6732 7.32455C24.7028 7.30119 24.7244 7.2692 24.735 7.23302C24.7456 7.19683 24.7447 7.15824 24.7324 7.12259C24.7201 7.08694 24.6971 7.05599 24.6664 7.03402C24.6358 7.01206 24.5991 7.00017 24.5613 7Z"
              stroke="#2F393E"
            />
            <path
              d="M25.2008 18V22H18.8008V18"
              stroke="#FF9D28"
              strokeWidth="0.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26 16H18V18H26V16Z"
              stroke="#FF9D28"
              strokeWidth="0.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 22V16"
              stroke="#FF9D28"
              strokeWidth="0.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.9992 16H20.1992C19.934 16 19.6796 15.8946 19.4921 15.7071C19.3046 15.5196 19.1992 15.2652 19.1992 15C19.1992 14.7348 19.3046 14.4804 19.4921 14.2929C19.6796 14.1054 19.934 14 20.1992 14C21.5992 14 21.9992 16 21.9992 16Z"
              stroke="#FF9D28"
              strokeWidth="0.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 16H23.8C24.0652 16 24.3196 15.8946 24.5071 15.7071C24.6946 15.5196 24.8 15.2652 24.8 15C24.8 14.7348 24.6946 14.4804 24.5071 14.2929C24.3196 14.1054 24.0652 14 23.8 14C22.4 14 22 16 22 16Z"
              stroke="#FF9D28"
              strokeWidth="0.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id={svgId1}>
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(3 3)"
            />
          </clipPath>
          <clipPath id={svgId2}>
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(3 3)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
